import { createStore, applyMiddleware, compose, Store } from 'redux'
import thunk from 'redux-thunk'

import reducers from './reducers/root'

import errorHandleMiddleware from './middleware/error-handle'

export let reduxStore: Store | null = null

const isBrowser = typeof window === 'object'

const makeStore = (initialState: object) => {
  const middleware = [thunk, errorHandleMiddleware]

  // use redux devtools in development mode
  const isDevelopment = process.env.NODE_ENV !== 'production'
  let composeEnhancers = compose

  if (
    isDevelopment &&
    isBrowser &&
    (window as $TSFixMe).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ) {
    composeEnhancers = (window as $TSFixMe).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  }

  const composedEnhancers = composeEnhancers<$TSFixMe>(
    applyMiddleware(...middleware)
  )

  const store = createStore(reducers, initialState, composedEnhancers)

  return store
}

const initStore = (initialState: object) => {
  const store = makeStore(initialState)
  reduxStore = store
  return store
}

export default initStore
